import { apiClient } from "./client";

export interface ClosedPeriod {
  tenant_id: string;
  period_start_month: string; // YYYY-MM-DD (1st)
  closed_at: string;
  closed_by: string | null;
  is_manual: boolean;
  reason: string | null;
}

export interface AuditEntry {
  id: number;
  ts: string;
  user_id: string | null;
  tenant_id: string | null;
  action: string;
  entity_type: string;
  entity_id: string;
  old_value: Record<string, unknown> | null;
  new_value: Record<string, unknown> | null;
  ip_address: string | null;
  user_agent: string | null;
  user_email: string | null;
}

export interface AuditFilter {
  entity_type?: string;
  action?: string;
  user_id?: string;
  from_date?: string;
  to_date?: string;
  limit?: number;
  offset?: number;
}

export const adminApi = {
  listAudit: (params: AuditFilter = {}) =>
    apiClient
      .get<AuditEntry[]>("/admin/audit", { params })
      .then((r) => r.data),

  listClosedPeriods: () =>
    apiClient.get<ClosedPeriod[]>("/admin/closed-periods").then((r) => r.data),

  closePeriod: (month: string, reason?: string) =>
    apiClient
      .post<ClosedPeriod>("/admin/close-period", { month, reason: reason ?? null })
      .then((r) => r.data),

  openPeriod: (month: string, reason: string) =>
    apiClient.post("/admin/open-period", { month, reason }).then((r) => r.data),

  recalc: (from: string, to: string) =>
    apiClient.post("/admin/recalc", { from, to }).then((r) => r.data),
};
